module.exports = __webpack_public_path__ + "bfb5a5d87e451dd56c1693f1fd52bed6.jpg";